import React from 'react';
//import { NavLink } from 'react-router-dom';
//import { Link } from 'react-scroll';
import { NavHashLink as Link } from 'react-router-hash-link'
import { useDispatch } from 'react-redux';

import classes from './Navbar.module.scss';

const Navbar = () => {
    const dispatch = useDispatch()

    const modeChangeHandler = () => {
        dispatch({ type: 'toggle' })
    }

    return (
        <div className={classes.Navbar}>
            <p className={classes.Blank}></p>
            <Link className={classes.Head} to='#home' smooth>P</Link>
            
                <ul className={classes.Navlinks}>
                    <li><Link activeClassName={classes.ActiveNavs} className={classes.Navs} to='#about' smooth>About</Link></li>
                    <li><Link activeClassName={classes.ActiveNavs} className={classes.Navs} to="#projects" smooth>Projects</Link></li>
                    <li><Link activeClassName={classes.ActiveNavs} className={classes.Navs} to="#contact" smooth>Contact</Link></li>
                </ul>
            <div className={classes.Toggle} id="_1st-toggle-btn">
                <input type="checkbox" onClick={modeChangeHandler} />
                <span></span>
            </div>
        </div>
    )
}

export default Navbar;